// Components
import { AdditionalInformation, FormValues } from '../..';
import { AddInfoModalHeader } from './AddInfoModalHeader';
import { Modal, ModalProps } from '@gif/shared-ui';

// Types
import styled from 'styled-components';
import { useEffect } from 'react';

// Hooks
import { useAdobeTracking } from '../../../hooks';

export type AddInfoModalFormSubmitProps = FormValues;

export interface AddInfoModalProps extends ModalProps {
  onFormSubmit?: (args: FormValues) => void;
  testId: string;
}

const StyledAddInfoModal = styled(Modal)`
  min-height: 32rem;
  .modal-body {
    padding: 0rem 2rem 0.5rem;
  }
`;

export const AddInfoModal = ({
  onClose,
  onFormSubmit,
  ...rest
}: AddInfoModalProps) => {
  // Analytics Page Tracking
  const { trackPageView } = useAdobeTracking();
  useEffect(() => {
    if (rest.isOpen) {
      trackPageView({
        type: 'Gaming Hub',
        subType: 'Additional Information',
      });
    }
  }, [rest.isOpen, trackPageView]);
  // End Analytics Page Tracking

  return (
    <StyledAddInfoModal
      onClose={onClose}
      customHeader={<AddInfoModalHeader onClose={onClose} />}
      {...rest}
    >
      <AdditionalInformation onFormSubmit={onFormSubmit} />
    </StyledAddInfoModal>
  );
};

export default AddInfoModal;
